import instance from '../config/axios';

export async function addProductToCart(token: string, id: string) {
  try {
    const result = await instance({
      url: '/api/v1/cart/add',
      data: { product_id: id },
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      validateStatus: (status) => {
        return status < 500;
      },
    });

    return { status: result.status, data: result.data };
  } catch (error) {
    console.error('Error adding product to cart:', error);
    return null;
  }
}
